import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Col } from 'react-grid-system';
//import ConfigManager from '../../../common/configManager/configManager';
import Label from '../../../components/shared/Label';
import * as types from '../../../constants';
import {
  ReportWidgetWrapper,
  ReportWrapper,
  ScrollWrapper,
  TitleWrapper,
} from './styles';

class ReportWidgetGazzanet extends Component {
  static childContextTypes = {
    breakpoints: PropTypes.arrayOf(PropTypes.number),
  };

  constructor(props) {
    super(props);
    this.state = {
      isMobile: false,
    };
  }

  getChildContext = () => ({
    breakpoints: [320, 600, 1024, 1440],
  });

  componentDidMount() {
    window.addEventListener('resize', this.resizeCallback);
    const interval = 30000;
    this.eventTimer = setInterval(this.getReportList, interval);
    this.getReportList();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeCallback);
    if (this.eventTimer) {
      clearInterval(this.eventTimer);
    }
  }

  getReportList = () => {
    const {
      competitionId, sportId, matchId, actions, widgetId,
    } = this.props;
    actions.getReportList(sportId, competitionId, matchId, '-1', 'it', widgetId);
  };

  setHeaderLabel = (home, away) => {
    const homeTeam = home.get('teamName');
    const awayTeam = away.get('teamName');
    const homeScore = home.get('score');
    const awayScore = away.get('score');
    return `${homeTeam} ${homeScore} - ${awayScore} ${awayTeam}`;
  };

  resizeCallback = () => {
    this.setState({
      isMobile: window.innerWidth <= 1023,
    });
  };

  render() {
    const {
      reportsAll,
      matchInfos,
      widgetId,
    } = this.props;
    const { isMobile } = this.state;
    const reports = reportsAll.get(widgetId);
    const matchInfo = matchInfos.get(widgetId);
    return (
      <ReportWidgetWrapper isMobile={isMobile}>
        {matchInfo && matchInfo.get('homeTeam') && matchInfo.get('awayTeam') &&
          <TitleWrapper className="has-background-primary">
            <Label
              label={this.setHeaderLabel(matchInfo.get('homeTeam'), matchInfo.get('awayTeam'))}
              weight="bold"
              margin="0 0 16px 10px"
              size={0.9}
              isCapitalize
              color="white"
              isTitleNarrowMedium
            />
          </TitleWrapper>
        }
        <ScrollWrapper>
          {reports && reports.reverse().map((comment, index) => (
            <ReportWrapper key={index}>
              <Col sm={2.5} md={2} style={{ paddingRight: 0, paddingLeft: 0, alignSelf: 'flex-start' }}>
                <Label
                  label={comment.get('commentTiming') || ''}
                  isTitleNarrowMedium
                  size={0.85}
                />
              </Col>
              <Col md={9.5} sm={9.5} style={{ paddingRight: 0, paddingLeft: 0 }}>
                <Label
                  label={comment.get('commentContent')}
                  size={0.85}
                />
              </Col>
            </ReportWrapper>
          ))
          }
        </ScrollWrapper>
      </ReportWidgetWrapper>
    );
  }
}

ReportWidgetGazzanet.propTypes = {
  actions: PropTypes.any,
  reportsAll: PropTypes.any,
  competitionId: PropTypes.any,
  sportId: PropTypes.any,
  matchId: PropTypes.any,
  matchInfos: PropTypes.any,
  //dictionary: PropTypes.any,
  widgetId: PropTypes.any,
};

export default connect(
  state => ({
    dictionary: state.dictionaryReducer.dictionary,
    reportsAll: state.reportListReducer.get('reportLists'),
    matchInfos: state.reportListReducer.get('reportMatchInfos'),
  }),
  dispatch => ({
    actions: {
      initDictionary: () =>
        dispatch({ type: types.INIT_DICTIONARY }),
      getReportList: (sportId, competitionId, matchId, period, lang, widgetId) =>
        dispatch({
          type: types.GET_REPORT_LIST_REQUEST,
          sportId,
          competitionId,
          matchId,
          period,
          lang,
          widgetId,
        }),
    },
  }),
)(ReportWidgetGazzanet);



// WEBPACK FOOTER //
// ./src/containers/GazzanetWidgets/ReportWidgetGazzanet/index.js